import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./Utils/Variables.css";
import { ApolloProvider } from "@apollo/client";
import { HashRouter as Router } from "react-router-dom";
import client from "./ApolloClient";
ReactDOM.render(
  <ApolloProvider client={client}>
    <Router>
      <App />
    </Router>
  </ApolloProvider>,
  document.getElementById("root")
);
